import { FlexCol } from "src/utils/flexLayouts";
import { TestRegistryFilters } from "./TestRegistryFilters";
import { TestRegistryList } from "./TestRegistryList";
import { TestRegistryFooter } from "./testRegistryButtons/TestRegistryFooterButtons";
import { FC, useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { TestRegistryContext } from "./store/testRegistryContext";
import { EditTest } from "./editTest/EditTest";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { NotificationsListFieldsRecordType, testRegistry } from "src/api/config/notifications.config";
import { getItems } from "src/modules/spItems/actions";
import { selectItems } from "src/modules/spItems/selectors";
import ReportsBreadCrumbs from "../ReportsBreadCrumbs";
import ListIcon from "src/components/ui-icons/reports/ListIcon";
import { AddTest } from "./testRegistryButtons/AddTest";
import Tests from "src/pages/DashboardPage/acadia/components/Tests/components/Tests";
import { DrawerComponent } from "src/components/DialogComponent";
import TestProvider from "src/pages/DashboardPage/acadia/components/Tests/store/TestProvider";

interface IProps {
  crumbs: string[];
}

export const TestTemplateRegistry: FC<IProps> = ({ crumbs }) => {
  const [selectedCollection, setSelectedCollection] = useState<NotificationsListFieldsRecordType["TestRegistry"] | {}>({});
  const [updateTest, setUpdateTest] = useState(false);
  const [testName, setTestName] = useState("");
  const [showModalDeleteTest, setShowModalDeleteTest] = useState(false);

  const { state } = useContext(TestRegistryContext);
  const testsRegistryList = useAppSelector(state => selectItems(state, testRegistry));
  const methods = useForm();
  const dispatch = useAppDispatch();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [addTestOnRegistry, setAddTestOnRegistry] = useState(false);

  useEffect(() => {
    dispatch(
      getItems({
        listName: testRegistry
      })
    );
  }, [updateTest]);

  function toggleDrawer() {
    setOpenDrawer(prev => !prev);
    setAddTestOnRegistry(prev => !prev);
    localStorage.setItem("questions", "");
  }

  return (
    <div>
      <ReportsBreadCrumbs reportsCrumbs={crumbs} Icon={ListIcon} path={state.test.Title} />

      <FormProvider {...methods}>
        {!state.editTest ? (
          <FlexCol className="py-5 px-7.5 gap-5 flex">
            <div className="bg-white shadow-custom py-5 px-[25px] rounded-md gap-[10px] font-medium">
              <TestRegistryFilters testName={testName} setTestName={setTestName} selectedCollection={selectedCollection} setSelectedCollection={setSelectedCollection} />
              <TestRegistryList testName={testName} selectedCollection={selectedCollection} testsList={testsRegistryList} />
              <AddTest openTest={toggleDrawer} />
              <DrawerComponent percentage="87" zIndex={50} open={openDrawer} toggleDrawer={toggleDrawer}>
                <TestProvider>
                  <Tests closeTests={toggleDrawer} addTestOnRegistry={addTestOnRegistry} shouldUpdateTestList={() => setUpdateTest(prev => !prev)} zIndex={50} />
                </TestProvider>
              </DrawerComponent>

              <TestRegistryFooter
                shouldUpdateTestList={() => setUpdateTest(prev => !prev)}
                testsList={testsRegistryList}
                setShowModalDeleteTest={setShowModalDeleteTest}
                showModalDeleteTest={showModalDeleteTest}
              />
            </div>
          </FlexCol>
        ) : (
          <EditTest shouldUpdateTestList={() => setUpdateTest(prev => !prev)} />
        )}
      </FormProvider>
    </div>
  );
};
